import { Grid as MuiGrid, GridProps as MuiGridProps, styled } from "@mui/material";

const StyledGrid = styled(MuiGrid)(() => ({
  // ... existing styles
}));

interface GridProps extends MuiGridProps {
  children: React.ReactNode;
}

export const Grid: React.FC<GridProps> = ({ children, ...props }) => {
  return <StyledGrid {...props}> {children}</StyledGrid>;
};

export default Grid;
